import React from 'react';
import(`./styles/${global.ThemeName}.scss`);

const LoadingSpinner = () => <div className="loading-spinner"></div>;

export default LoadingSpinner;
